import React, { useState } from "react";
import { toast } from "react-toastify";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import LoadingButton from "components/button/loading";
import ApiDataBase from "server";

const DeleteMissionTemplate = () => {
    const { toggle } = useModal();
    const {
        pendingDeleteMissionTemplate,
        setPendingDeleteMissionTemplate,
        refreshMissionTemplates,
        setRefreshMissionTemplates,
    } = UseContext();
    const [isLoading, setIsLoading] = useState(false);

    const templateName =
        pendingDeleteMissionTemplate?.name ||
        pendingDeleteMissionTemplate?.title ||
        "";

    const handleConfirm = () => {
        if (!pendingDeleteMissionTemplate?._id) {
            toggle();
            return;
        }
        setIsLoading(true);
        ApiDataBase.deleteMissionTemplate(
            { id: pendingDeleteMissionTemplate._id },
            () => {
                setIsLoading(false);
                setPendingDeleteMissionTemplate(null);
                setRefreshMissionTemplates(!refreshMissionTemplates);
                toast.success("Fiche de poste supprimée");
                toggle();
            },
            (err) => {
                setIsLoading(false);
                console.error(err);
                toast.error("Suppression impossible");
            }
        );
    };

    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>
                Supprimer la fiche de poste
            </Modalheader>
            <ModalBody>
                <p className={"ft-sm text-gray-700"}>
                    Êtes-vous sûr de vouloir supprimer la fiche de poste{" "}
                    <span className={"font-bold"}>{templateName}</span> ? La
                    suppression de la fiche de poste n’affectera pas les
                    missions créees.
                </p>
            </ModalBody>
            <ModalFooter>
                <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
                    Annuler
                </Button>
                {isLoading ? (
                    <LoadingButton size={"LG"}>Suppression…</LoadingButton>
                ) : (
                    <Button size={"LG"} color={"PRIMARY"} onClick={handleConfirm}>
                        Confirmer
                    </Button>
                )}
            </ModalFooter>
        </>
    );
};

export default DeleteMissionTemplate;
